var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        "before-close": _vm.close,
        "close-on-click-modal": false,
        width: "50%",
        top: "7vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.show = $event
        },
        open: _vm.openDialog,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dia-tit", attrs: { slot: "title" }, slot: "title" },
        [
          _c("i"),
          _c("span", { domProps: { textContent: _vm._s(_vm.GoodsTitle) } }),
        ]
      ),
      _c(
        "el-form",
        {
          ref: "formData",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物品名称：", prop: "title" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入物品名称" },
                model: {
                  value: _vm.formData.title,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "title", $$v)
                  },
                  expression: "formData.title",
                },
              }),
            ],
            1
          ),
          _vm.goodsData === null
            ? _c(
                "el-form-item",
                { attrs: { label: "初始数量" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      label: "请填写初始数量",
                      disabled: _vm.goodsData !== null,
                    },
                    model: {
                      value: _vm.formData.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "amount", $$v)
                      },
                      expression: "formData.amount",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.goodsData !== null
            ? _c("el-form-item", { attrs: { label: "当前数量" } }, [
                _c("span", [_vm._v(_vm._s(_vm.formData.amount))]),
              ])
            : _vm._e(),
          _c(
            "el-form-item",
            { attrs: { label: "物品单位：" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入物品单位" },
                model: {
                  value: _vm.formData.unit,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "unit", $$v)
                  },
                  expression: "formData.unit",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              staticClass: "dialog-btn",
              attrs: { type: "primary" },
              on: { click: _vm.saveRoleForm },
            },
            [_vm._v("确 定")]
          ),
          _c(
            "el-button",
            {
              staticClass: "dialog-btn",
              attrs: { type: "info" },
              on: { click: _vm.close },
            },
            [_vm._v("取 消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }